import type { Model } from "@/schemas/model.schema";
import { $t } from "@/services/i18n";

/**
 * Human sentence for a deprecated model, composed from whatever deprecation
 * fields are actually present: date, replacement, both, or neither.
 *
 * Shared on purpose: the agent's model picker (LLMsDropdown), the selected
 * model summary (ModelCard) and the Integrations chips (ModelChip) must all
 * tell the user the SAME thing about the same model - the two screens
 * disagreeing is what AI-1068 came from. Takes only what it reads, so callers
 * holding a projection of the model (the /integration-credentials/models
 * payload) can use it too.
 */
export function deprecationTooltipText(model?: Pick<Model, "deprecation"> | null): string {
  const dep = model?.deprecation;
  if (dep?.date && dep?.replacement) {
    return $t("agents:deprecated_tooltip_full", { date: dep.date, replacement: dep.replacement });
  }
  if (dep?.date) return $t("agents:deprecated_tooltip_date", { date: dep.date });
  if (dep?.replacement) {
    return $t("agents:deprecated_tooltip_replacement", { replacement: dep.replacement });
  }
  return $t("agents:model_deprecated_banner_no_date");
}
